angular.module('app').controller('SessionTypesCtrl', function($controller, $scope, $mdToast, $http) {
    "ngInject";

    var main = this;

    main.name = 'session_set';
    main.defaults = {};
    main.moods = [];

    angular.extend(main, $controller('ListCtrl', {'$scope': $scope, 'main': main}));

    // Load global moods for selection
    main.loadMoods = function() {
        $http({
            'url': '/api/v1/admin/mood?results_per_page=1000',
            'method': 'GET'
        }).then(
            function(response) {
                main.moods = response.data.objects;
            }
        );
    };

    main.loadMoods();
    main.prepareQuery = function() {
        var params = main._prepareQuery();
        params.q.order_by = [{'field': 'session_type', 'direction': 'asc'},{'field': 'name', 'direction': 'asc'}];
        return params;
    }

    main.changeDefault = (newDefault) => {
        main.items.forEach((set) => {
            console.log(set, newDefault);
            if(newDefault.session_type == set.session_type && newDefault !== set) {
                set.default = false;
            }
        });
    }

    main.save = function() {
        if(main.loading) {
            var alert = $mdToast.simple().textContent("Save already in progress");
            $mdToast.show(alert);
            return;
        }

        main.loading = $http({'method': 'PUT', 'url': '/api/v1/admin/session_set', 'data': main.items});
        main.loading.then(
            function(response) {
                var message = "Saved";
                var alert = $mdToast.simple().textContent(message);
                $mdToast.show(alert);
                main.items = response.data;
                main.loading = false;
            },
            function(response) {
                main.loading = false;
                return response;
            }
        );

        return main.loading;
    }
});
